var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { LitElement, html } from 'lit';
import { property } from 'lit/decorators.js';
import { findStyles } from './styles.js';
class QboFind extends LitElement {
    constructor() {
        super(...arguments);
        this.selector = '';
        this.cssClass = '';
        this.selectorRoot = '';
    }
    static { this.styles = [
        findStyles
    ]; }
    render() {
        return html `<slot>
<input type="text" @input="${this.handleInput}" placeholder="Filter ...">
    </slot>
    `;
    }
    connectedCallback() {
        super.connectedCallback();
        this.root = this.getRoot();
    }
    getRoot() {
        if (this.selectorRoot) {
            // Find the nearest ancestor with the specified tag name
            let ancestor = this.closest(this.selectorRoot);
            // If ancestor is not found in the current shadow DOM context, look up in the document
            return ancestor ? ancestor : document;
        }
        else {
            return document;
        }
    }
    handleInput(event) {
        const searchText = event.target.value.toLowerCase();
        const elements = this.root?.querySelectorAll(this.selector);
        if (elements === null || elements === undefined)
            return;
        elements.forEach(element => {
            const textContent = element.textContent?.toLowerCase() || "";
            if (!textContent.includes(searchText)) {
                if (this.cssClass)
                    element.classList.add(this.cssClass);
                else if (element instanceof HTMLElement)
                    element.style.display = 'none';
            }
            else {
                if (this.cssClass)
                    element.classList.remove(this.cssClass);
                else if (element instanceof HTMLElement)
                    element.style.display = '';
            }
        });
    }
}
__decorate([
    property({ type: String }),
    __metadata("design:type", Object)
], QboFind.prototype, "selector", void 0);
__decorate([
    property({ type: String }),
    __metadata("design:type", Object)
], QboFind.prototype, "cssClass", void 0);
__decorate([
    property({ type: String }),
    __metadata("design:type", Object)
], QboFind.prototype, "selectorRoot", void 0);
customElements.define('qbo-find', QboFind);
//# sourceMappingURL=qbo-find.js.map